/* ============================================================
   Mini Chef - Foldable Helper Tower
   Shared, dependency-free interactions:
     1) CTA smooth-scroll to the buy box (main-product)
     2) Fold section  - accessible open/folded tab toggle
     3) Heights section - interactive 3-level platform selector
   All progressive: with JS off, static content still renders.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mctPage) return;
  window.__mctPage = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) CTA smooth scroll to the buy box ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.mct-btn--cta, a.mct-btn--ghost') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var el = document.getElementById(href.slice(1)) ||
             (href.indexOf('main-product') > -1 ? document.querySelector('[id*="main-product"]') : null);
    if (!el) return; /* let the browser handle the raw hash */
    e.preventDefault();
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  });

  /* ---------- 2) Fold toggle (ARIA tablist) ---------- */
  function activateTab(tab, tabAttr, panelAttr) {
    var root = tab.closest('[data-mct-fold]');
    if (!root) return;
    var tabs = root.querySelectorAll('[' + tabAttr + ']');
    var panels = root.querySelectorAll('[' + panelAttr + ']');
    var target = tab.getAttribute('aria-controls');
    var i;
    for (i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
    }
    for (i = 0; i < panels.length; i++) {
      if (panels[i].id === target) panels[i].removeAttribute('hidden');
      else panels[i].setAttribute('hidden', '');
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-mct-fold-tab]') : null;
    if (tab) activateTab(tab, 'data-mct-fold-tab', 'data-mct-fold-panel');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tab = e.target.closest ? e.target.closest('[data-mct-fold-tab]') : null;
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-mct-fold-tab]'));
    var idx = tabs.indexOf(tab);
    var next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
    tabs[next].focus();
    activateTab(tabs[next], 'data-mct-fold-tab', 'data-mct-fold-panel');
    e.preventDefault();
  });

  /* ---------- 3) Heights selector ---------- */
  function setHeight(btn) {
    var root = btn.closest('[data-mct-heights]');
    if (!root) return;
    var btns = root.querySelectorAll('[data-mct-height]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
    }
    var idx = btn.getAttribute('data-index');
    var photos = root.querySelectorAll('[data-mct-height-photo]');
    for (var p = 0; p < photos.length; p++) {
      if (photos[p].getAttribute('data-index') === idx) photos[p].classList.remove('is-hidden');
      else photos[p].classList.add('is-hidden');
    }
    var lead = root.querySelector('[data-mct-desc-lead]');
    if (lead) lead.textContent = btn.getAttribute('data-lead') || '';
    var text = root.querySelector('[data-mct-desc-text]');
    if (text) text.textContent = btn.getAttribute('data-desc') || '';
    var live = root.querySelector('[data-mct-height-live]');
    if (live) live.textContent = btn.getAttribute('data-live') || '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mct-height]') : null;
    if (btn) setHeight(btn);
  });

  /* initialise the default-pressed height button on load */
  function initHeights() {
    var roots = document.querySelectorAll('[data-mct-heights]');
    for (var i = 0; i < roots.length; i++) {
      var pressed = roots[i].querySelector('[data-mct-height][aria-pressed="true"]') ||
                    roots[i].querySelector('[data-mct-height]');
      if (pressed) setHeight(pressed);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeights);
  } else {
    initHeights();
  }

  /* ---------- 4) Transformation animation: pause/play (WCAG 2.2.2), default paused under reduced motion ---------- */
  function setAnim(wrap, playing) {
    var img = wrap.querySelector('[data-mct-anim-img]');
    var btn = wrap.querySelector('[data-mct-anim-toggle]');
    var lbl = wrap.querySelector('[data-mct-anim-label]');
    if (!img || !btn) return;
    img.src = playing ? wrap.getAttribute('data-anim-src') : wrap.getAttribute('data-poster-src');
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    /* Labels are rendered by Liquid via the theme locale files, so they follow the
       storefront language instead of being hardcoded here. */
    if (lbl) {
      /* Fall back to a literal, never to lbl.textContent: that always holds the
         OPPOSITE state's label, so an empty translation would leave "Pause"
         showing while aria-pressed says paused. */
      var key = playing ? 'data-label-pause' : 'data-label-play';
      lbl.textContent = wrap.getAttribute(key) || (playing ? 'Pause' : 'Play');
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mct-anim-toggle]') : null;
    if (!btn) return;
    var wrap = btn.closest('[data-mct-anim]');
    if (wrap) setAnim(wrap, btn.getAttribute('aria-pressed') !== 'true');
  });
  function initAnim() {
    if (!reduceMotion) return;
    var wraps = document.querySelectorAll('[data-mct-anim]');
    for (var i = 0; i < wraps.length; i++) setAnim(wraps[i], false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnim);
  } else {
    initAnim();
  }
})();
